var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-info",class:{ isMobile: _vm.isMobile }},[_c('div',{staticClass:"img-box"},[_c('img',{staticClass:"block",attrs:{"alt":`Icon - ${_vm.title}`,"src":`/img/${_vm.icon}`}})]),_c('div',{staticClass:"icon-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"icon-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }